import { createAsyncAction } from 'redux-promise-middleware-actions';

import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const usersProfileConstants = {
    USERS_PROFILE_INFO_LOADED: 'USERS_PROFILE_INFO_LOADED',
};

export const usersProfileInfoPendingConstants = getActionTypesResult(usersProfileConstants, '_PENDING');
export const usersProfileInfoFulfilledConstants = getActionTypesResult(usersProfileConstants, '_FULFILLED');
export const usersProfileInfoRejectedConstants = getActionTypesResult(usersProfileConstants, '_REJECTED');

export const fetchUserProfileInfo = createAsyncAction(
    usersProfileConstants.USERS_PROFILE_INFO_LOADED,
    userId => api
        .get(`users/${userId}/profile`)
        .then(res => ({ data: res.data, userId })),
    userId => userId
);
